import Immutable from 'immutable';
import {
  SET_INSTITUTION_DATA,
  SET_QUALIFICATION_DATA,
  SET_COURSE_DATA,
  QUALIFICATION_ENROLMENT_START,
  QUALIFICATION_ENROLMENT_SUCCESS,
  QUALIFICATION_ENROLMENT_FAILURE,
  QUALIFICATION_EXTERNAL_ENROLMENT_START,
  SET_INSTITUTION_CATEGORY_COURSES_DATA,
  SET_INSTITUTION_YOUR_COURSES_DATA,
} from './actions';

const initialState = Immutable.fromJS({
  enrolmentInProgress: false,
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function Portal(state = initialState, action = {}) {
  switch (action.type) {
    case SET_COURSE_DATA: {
      let newState = state;
      newState = newState.set(
        action.courseData.path,
        Immutable.fromJS(action.courseData)
      );
      newState = newState.set('course', action.courseData.path);
      return newState;
    }
    case SET_INSTITUTION_DATA: {
      return state.set(
        action.institutionData.name,
        Immutable.fromJS(action.institutionData)
      );
    }
    case SET_QUALIFICATION_DATA: {
      let newState = state;
      newState = newState.set(
        action.qualificationData.path,
        Immutable.fromJS(action.qualificationData)
      );
      newState = newState.set('qualification', action.qualificationData.path);
      return newState;
    }
    case SET_INSTITUTION_YOUR_COURSES_DATA: {
      const courses = Immutable.fromJS(action.courses).map((course) => {
        return course.merge({
          mode: 'goToCourse',
        });
      });
      return state.updateIn(
        [action.portal, 'pageSections'],
        Immutable.List(),
        (pageSections) => {
          return pageSections.map((pageSection) => {
            if (pageSection.get('name') === 'yourCourses') {
              return pageSection.setIn(['data', 'courses'], courses);
            }
            return pageSection;
          });
        }
      );
    }
    case QUALIFICATION_EXTERNAL_ENROLMENT_START: {
      const { externalEnrolmentLink } = action;
      return state.set('enrolmentInProgress', {
        isExternalEnrolment: true,
        externalEnrolmentLink,
      });
    }
    case QUALIFICATION_ENROLMENT_START: {
      const { qualification } = action;
      let newState = state.set(
        qualification.get('path'),
        qualification.set('isEnrolling', true)
      );
      newState = newState.set('enrolmentInProgress', true);
      return newState;
    }
    case QUALIFICATION_ENROLMENT_FAILURE: {
      const { qualification } = action;
      let newState = state.set(
        qualification.get('path'),
        qualification.set('isEnrolling', false)
      );
      newState = newState.set('enrolmentInProgress', false);
      return newState;
    }
    case QUALIFICATION_ENROLMENT_SUCCESS: {
      const { qualification } = action;
      let newState = state;
      let newQualification = qualification;
      newQualification = newQualification.set('isEnrolled', true);
      newQualification = newQualification.set('isEnrolling', false);
      newState = newState.set(qualification.get('path'), newQualification);
      newState = newState.set('enrolmentInProgress', false);
      return newState;
    }
    case SET_INSTITUTION_CATEGORY_COURSES_DATA: {
      const { category, courses, portal } = action;
      return state.updateIn(
        [portal, 'pageSections'],
        Immutable.List(),
        (pageSections) => {
          return pageSections.map((pageSection) => {
            if (pageSection.get('name') === 'courseCategories') {
              return pageSection.updateIn(
                ['data', 'categories'],
                Immutable.List(),
                (categories) => {
                  return categories.map((cat) => {
                    if (cat.get('name') === category) {
                      return cat.set('courses', Immutable.fromJS(courses));
                    }
                    return cat;
                  });
                }
              );
            }
            return pageSection;
          });
        }
      );
    }
    default: {
      return state;
    }
  }
}
